<template>
  <I18nLinkWithFallback
    name="exhibitions-slug"
    :localizedData="attributes"
    :class="$style.root"
  >
    <CoreImageComponent
      v-if="attributes?.cover_image?.data?.attributes"
      :image="attributes?.cover_image?.data?.attributes"
      :class="$style.image"
    />

    <div :class="$style.info">
      <div>
        {{ title }}
      </div>

      <CoreDateTimeRangeComponent
        v-if="attributes?.date_start"
        :dateStart="attributes?.date_start"
        :dateEnd="attributes?.date_end"
      />

      <div
        v-if="localizedData?.exhibition_type"
        :class="$style.type"
      >
        {{ $t(`exhibitions.${localizedData?.exhibition_type}`) }}
      </div>

    </div>
  </I18nLinkWithFallback>
</template>

<script setup>
const props = defineProps({
  data: Object
})

const attributes = computed(() => {
  return baseStrapiGetAttributes(props?.data)
})

const getLocalizedData = i18nGetLocalizedData

const localizedData = computed(() => {
  return i18nGetLocalizedData(attributes?.value)
})

const title = computed(() => i18nGetLocalizedTitle(localizedData?.value))

const coverImage = computed(() => localizedData.value?.cover_image?.data?.attributes)
</script>

<style module>
.root {
  composes: reset-link from global;

  --base--image--aspect-ratio: 9 / 6;
  --base--image--object-fit: cover;

  display: flex;
  flex-direction: column;
  gap: var(--unit--spacer);
}

.image {
  transition: filter var(--transition--default);
}

.root:hover .image {
  filter: invert(100%) grayscale(100%);
}

.info {
  composes: font-size-small from global;
}

.type {
  color: var(--color--gray--dark);
}
</style>
